import Manager from "./src/Manager";
import Triggering from "./src/Triggers";

const Dialog = new Manager();
export default Dialog;
export const Triggers = new Triggering();
export {default as ConfigBuilder} from "./src/ConfigBuilder";

window.Dialog = Dialog;
